<template>
  <error-page-layout>
    <span class="display-1 d-block text-primary">404</span>
    <div class="mb-4 lead">{{ $t("error-pages.body-404") }}</div>
    <router-link to="/" class="btn btn-link">
      {{ $t("error-pages.footer-link") }}
    </router-link>
  </error-page-layout>
</template>

<script>
import ErrorPageLayout from "@/layouts/ErrorPageLayout";

export default {
  components: { ErrorPageLayout }
};
</script>